import { ORDER_LIST_FAIL, ORDER_LIST_REQUEST, ORDER_LIST_SUCCESS, ORDER_LIST_UPDATE } from "../constats/order.constant";

export const orderListReducer = (state={},action) => {
    switch (action.type) {
        case ORDER_LIST_REQUEST:
            return {
                loading: true
            };
        case ORDER_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        case ORDER_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            }
        case ORDER_LIST_UPDATE:
            return {
                ...state,
                data: {
                    ...state.data,
                    data: state.data.data.map(element =>
                        element.id === action.payload.id ? { ...action.payload } : element
                    )
                }
            };
        default:
            return state;
    }
} 